<template>
  <div @click="back" class="rpage">
    <img src="../../assets/img/rPageIcon.png" alt="" />
    返回
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    back() {
      window.history.back();
    },
  },
};
</script>
<style lang="less" scoped>
.rpage {
  width: 100%;
  height: 45px;
  opacity: 1;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 16px;
  align-items: center;
  display: flex;
  justify-content: center;
  height: calc(45px+ constant(safe-area-inset-bottom));
  /*兼容 IOS>11.2*/
  height: calc(45px + env(safe-area-inset-bottom));
  /*
    margin-bottom: constant(safe-area-inset-bottom);
    margin-bottom: env(safe-area-inset-bottom);
    */
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
}
</style>
